import { AHTag, Box, TouchableBox, useSpaceSize, useTheme } from "arkh";
import React from "react";
import { FlatList } from "react-native";
import { graphql, useFragment } from "react-relay";
import { KPIAnalyticsSectionSelector_KPI$key } from "./__generated__/KPIAnalyticsSectionSelector_KPI.graphql";

export function KPIAnalyticsSectionSelector(props: {
  kpi: KPIAnalyticsSectionSelector_KPI$key;
  selectedSectionIds: string[] | undefined;
  setSelectedSectionIds: React.Dispatch<
    React.SetStateAction<string[] | undefined>
  >;
}) {
  const data = useFragment(
    graphql`
      fragment KPIAnalyticsSectionSelector_KPI on KPI {
        activeSections {
          id
          title
          assignedTeam {
            id
            icon
            name
            color
          }
        }
      }
    `,
    props.kpi
  );
  const theme = useTheme();
  const space = useSpaceSize("xxsmall");

  return (
    <Box
      style={{
        height: data.activeSections.length < 2 ? 0 : 50,
        borderBottomWidth: 1,
        borderTopWidth: 1,
      }}
      borderColor="border-primary"
    >
      <FlatList
        data={data.activeSections ?? []}
        style={{ height: 50, backgroundColor: theme.surface }}
        contentContainerStyle={{
          alignItems: "center",
          paddingHorizontal: space,
        }}
        horizontal
        showsHorizontalScrollIndicator={false}
        renderItem={({ item }) => (
          <TouchableBox
            onPress={() => {
              props.setSelectedSectionIds((selected) => {
                if (selected?.includes(item.id)) {
                  const r = selected.filter((id) => id !== item.id);
                  return r.length === 0 ? undefined : r;
                } else {
                  return [...(selected ?? []), item.id];
                }
              });
            }}
            spaceHorizontal="small"
          >
            <AHTag
              selected={
                !props.selectedSectionIds ||
                props.selectedSectionIds?.includes(item.id)
              }
              title={item.title ?? item.assignedTeam?.name ?? ""}
              color={item.assignedTeam?.color ?? "#000"}
            />
          </TouchableBox>
        )}
      />
    </Box>
  );
}
